export default __webpack_public_path__ + "static/media/WD-main1.787d5cca.jpg";